import { render, staticRenderFns } from "./MerchantStatistics.vue?vue&type=template&id=4377a57c&scoped=true"
import script from "./MerchantStatistics.vue?vue&type=script&lang=js"
export * from "./MerchantStatistics.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatistics.vue?vue&type=style&index=0&id=4377a57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377a57c",
  null
  
)

export default component.exports